import(/* webpackMode: "eager" */ "/usr/src/app/src/app/[locale]/(root)/error.jsx")